export const isUserAuthenticated = () => {
    const storedLoggedInStatus = localStorage.getItem('isLoggedIn');
    if (storedLoggedInStatus) {
        return JSON.parse(storedLoggedInStatus)
    }
    return false;
}

export const getUserToken = () => {
    try {
        const userDetails = JSON.parse(localStorage.getItem('userDetails'))
        return userDetails.token
    } catch (error) {
        return null;
    }
}

export const loadUserDetails = () => {
    try {
        const userStrObj = localStorage.getItem('userDetails');
        if (userStrObj === null) {
            return null;
        }
        return JSON.parse(userStrObj);
    } catch (error) {
        return null;
    }
}

export const getUserFullName = (userInfos) => {
    const { firstName = '', lastName = '' } = userInfos;
    return `${firstName} ${lastName}`.trim();
};